<template>
  <div
    class="content"
    :class="moduleInfo.Module.CssClass"
  >
    <div
      v-if="loaded"
      class="max-w-screen-2xl mx-auto relative mb-6 mt-10 md:mt-20 md:mb-10"
      :class="{
        'no-margin-top': moduleInfo.Module.ModuleProperties.ModuleNoMarginTop === 'True'
      }"
    >
      <!-- Title -->
      <div class="max-w-screen-xl mx-auto">
        <div class="container">
          <h2
            v-if="hasPropertyValue('Overtitle', moduleInfo.Module.ModuleProperties, firstModuleDataItem)"
            class="overtitle text-htz-red text-center"
          >
            {{ getPropertyValue($t,"Overtitle",moduleInfo.Module.ModuleProperties,firstModuleDataItem) }}
          </h2>
          <h2
            v-if="hasPropertyValue('Title',moduleInfo.Module.ModuleProperties,firstModuleDataItem)"
            class="headline-2 my-2 pb-2"
            :class="{'text-center': moduleInfo.Module.ModuleProperties.ModuleHasCenterTitle ==='True'}"
          >
            <span
              v-if="hasPropertyValue('IntroTitle',moduleInfo.Module.ModuleProperties,firstModuleDataItem)"
              class="-mt-8"
            >
              {{ getPropertyValue($t,"IntroTitle",moduleInfo.Module.ModuleProperties,firstModuleDataItem) }}
            </span>

            {{ getPropertyValue($t,"Title",moduleInfo.Module.ModuleProperties,firstModuleDataItem) }}
          </h2>
        </div>
      </div>

      <!-- Image if Above -->
      <div
        v-if="moduleInfo.Module.ModuleProperties.ModuleHasImageAbove === 'True' && moduleInfo.Module.ModuleProperties.ModuleHideImage !== 'True'"
        class="relative mt-6 xl:mt-8"
      >
        <vue-picture
          v-if="moduleInfo.Module.ModuleProperties.ModuleHideImage !== 'True' && firstModuleDataItem?.MediaGallery.length"
          :image="firstModuleDataItem.MediaGallery[0]"
          css-class="paragraph-img max-h-460 object-cover"
        />
      </div>

      <!-- Content -->
      <div class="max-w-screen-xl mx-auto">
        <div class="container">
          <div class="flex flex-col">
            <div class="my-8">
              <div class="columns-2 max-w-screen-lg mx-auto heading-sizes">
                <p
                  v-if="hasPropertyValue('HighlightedText', moduleInfo.Module.ModuleProperties, firstModuleDataItem)"
                  class="p-base content-text leading-normal mb-6"
                  v-html="getPropertyValue($t, 'HighlightedText', moduleInfo.Module.ModuleProperties,firstModuleDataItem)"
                />
                <p
                  v-if="hasPropertyValue('Text', moduleInfo.Module.ModuleProperties, firstModuleDataItem)"
                  class="p-sm content-text text-htz-steel leading-relaxed lg:leading-8"
                  v-html="getPropertyValue($t, 'Text', moduleInfo.Module.ModuleProperties,firstModuleDataItem)"
                />
              </div>
              <div class="max-w-screen-lg mx-auto">
                <VirtualLink
                  v-if="hasPropertyValue('UrlText', moduleInfo.Module.ModuleProperties, firstModuleDataItem)"
                  :href="getHref(moduleInfo.Module.ModuleProperties, firstModuleDataItem)"
                  class-list="btn-red mt-5"
                >
                  {{ getPropertyValue($t,'UrlText', moduleInfo.Module.ModuleProperties, firstModuleDataItem) }}
                </VirtualLink>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Image if Below -->
      <div
        v-if="moduleInfo.Module.ModuleProperties.ModuleHasImageAbove === 'False' && moduleInfo.Module.ModuleProperties.ModuleHideImage !== 'True'"
        class="relative my-3"
      >
        <vue-picture
          v-if="moduleInfo.Module.ModuleProperties.ModuleHideImage !== 'True' && firstModuleDataItem?.MediaGallery.length"
          :image="firstModuleDataItem.MediaGallery[0]"
          css-class="paragraph-img max-h-460 object-cover"
        />
      </div>
    </div>
  </div>
</template>
<script>
import VuePicture from "../../includes/VuePicture";
import {selfDataRequestMixin} from "@/mixins";

export default {
  name: "ParagraphTwoColumns",
  components: {
    VuePicture,
  },
  mixins: [selfDataRequestMixin],
  props: {
    moduleInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      galleryType: 'paragraphTwoColumnImage',
    };
  },
  methods:{

  }

};
</script>
